function parseInline(text, keyPrefix) {
  const parts = [];
  const regex = /(\*\*(.+?)\*\*|\*(.+?)\*|_(.+?)_)/g;
  let lastIndex = 0;
  let match;
  let i = 0;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) parts.push(text.slice(lastIndex, match.index));
    if (match[2] !== undefined) {
      parts.push(<strong key={`${keyPrefix}-${i++}`}>{match[2]}</strong>);
    } else {
      parts.push(<em key={`${keyPrefix}-${i++}`}>{match[3] !== undefined ? match[3] : match[4]}</em>);
    }
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return parts;
}

/**
 * RichText — renders the markdown-lite syntax RichTextEditor writes
 * (**bold**, *italic*, "- " bullets, "1. " numbered lists) as real
 * React elements. Never uses dangerouslySetInnerHTML — plain text
 * stays plain text, so there is no HTML-injection surface at all.
 */
export default function RichText({ text, className = "" }) {
  if (!text) return null;

  const lines = text.split("\n");
  const blocks = [];
  let currentList = null;
  let paragraphLines = [];

  const flushParagraph = () => {
    if (paragraphLines.length) {
      blocks.push({ type: "p", lines: paragraphLines });
      paragraphLines = [];
    }
  };
  const flushList = () => {
    if (currentList) {
      blocks.push(currentList);
      currentList = null;
    }
  };

  lines.forEach((line) => {
    const bulletMatch = /^\s*[-•]\s+(.*)$/.exec(line);
    const numberedMatch = /^\s*\d+[.)]\s+(.*)$/.exec(line);
    if (bulletMatch) {
      flushParagraph();
      if (!currentList || currentList.type !== "ul") { flushList(); currentList = { type: "ul", items: [] }; }
      currentList.items.push(bulletMatch[1]);
    } else if (numberedMatch) {
      flushParagraph();
      if (!currentList || currentList.type !== "ol") { flushList(); currentList = { type: "ol", items: [] }; }
      currentList.items.push(numberedMatch[1]);
    } else if (line.trim() === "") {
      flushList();
      flushParagraph();
    } else {
      flushList();
      paragraphLines.push(line);
    }
  });
  flushList();
  flushParagraph();

  return (
    <div className={className}>
      {blocks.map((block, bi) => {
        if (block.type === "ul") {
          return (
            <ul key={bi} className="mt-1 list-disc space-y-0.5 pl-5">
              {block.items.map((item, ii) => <li key={ii}>{parseInline(item, `${bi}-${ii}`)}</li>)}
            </ul>
          );
        }
        if (block.type === "ol") {
          return (
            <ol key={bi} className="mt-1 list-decimal space-y-0.5 pl-5">
              {block.items.map((item, ii) => <li key={ii}>{parseInline(item, `${bi}-${ii}`)}</li>)}
            </ol>
          );
        }
        return (
          <p key={bi} className={bi > 0 ? "mt-2" : ""}>
            {block.lines.map((line, li) => (
              <span key={li}>
                {parseInline(line, `${bi}-${li}`)}
                {li < block.lines.length - 1 && <br />}
              </span>
            ))}
          </p>
        );
      })}
    </div>
  );
}